export default __webpack_public_path__ + "static/thumbnail_dead-c545a81ef9508fa1c158d82b8708ff32.jpg";